import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer';
import {connect} from 'react-redux';
import HeaderAfterLogin from "../HeaderAfterLogin";
import SidebarMobile from "../SidebarMobile";
import {getAccessToken, getSchoolYear} from "../../utils/authority";
import {toast} from "react-toastify";
import UserController from "../../services/system/user/user-controller";
class Layout extends React.Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        isCommonFetching: PropTypes.bool,
    };

    constructor(...args) {
        super(...args);
        this.state = {
            modalLogin: false,
            modalSignup: false,
            modalSignUpMember: false,
            haveToken: false,
            signupInfo: null,
            modalWarningInfo: false,
            listCategory: [],
            modalLockAccount: false,
            sidebarMobile: false,
            isUpdate: false
        };
    }
    UNSAFE_componentWillMount() {
        this.getMyPermission()
    }

    componentDidMount() {
        let token = getAccessToken();
        if (token)
            this.setState({haveToken: true});
        else {
            //haovc remove
            // history.push("/");
        }
    }
    getMyPermission(){
        UserController.getPermission(res => {
            if (!res.success) {
                toast.error("Lỗi lấy danh sách")
            } else {
                res.data.push("ACCOUNT_EDIT_PROFILE")
                res.data.push("ACCOUNT_CHANGE_PWD")
                res.data.push("ACCOUNT_FORGOT_PWD")
                localStorage.setItem("sas_school_per", JSON.stringify(res.data));
            }
        }).catch((error) => {
            toast.error("Lỗi lấy danh sách")
        })
    }
    logout = () => {
        // let url =  window.location.hash.split('/');
        // if (url.length == 2 && !url[1]){
        //     console.log("nó chạy vô đây nè>>>>, done")
        // }else{
        // forceLogout()
        // return history.push("/");
        // console.log("check url22@@@>>>>>>>>", url)
        // }
        // console.log("check url22@@@>>>>>>>>", url)
        // if (url[2] && (url[2] == "complete-profile" || url[2] == "confirm-email")){

    };

    setSignupInfo = (signupInfo) => {
        this.setState({signupInfo}, () => {
            this.modalSignupClose();
            this.onOpenModalOtp()
        })
    };
    onOpenModalOtp = (event) => {
        // event.preventDefault();
        this.setState({modalOtp: true});
    };
    modalSignupClose = () => this.setState({modalSignup: false});
    showModalWarningInfo = () => {
        this.setState({modalWarningInfo: true});
    };
    showModalWarningEmail = () => {
        this.setState({modalWarningEmail: true});
    };

    saveOtp = (tokenForgotPass, otp) => {
        this.setState({
            tokenForgotPass,
            otp,
        })
    };
    toggleSidebarMobile = () => {
        let sidebar = this.state.sidebarMobile
        this.setState({
            sidebarMobile: !sidebar
        })
    };


    render() {
        let token = getAccessToken();
        if (!token) this.logout()
        return (
            <div id="mainContainer">
                <div className="loading"
                     style={this.props.isFetching || this.props.isCommonFetching ? {display: 'block'} : {display: 'none'}}>
                    <div className="lds-dual-ring"></div>
                </div>

                {this.state.haveToken && <HeaderAfterLogin listCategory={this.state.listCategory}
                                                          showModalWarningInfo={this.showModalWarningInfo}
                                                          showModalWarningEmail={this.showModalWarningEmail} toggleSidebarMobile={this.toggleSidebarMobile}/>}
                <div className="content-wrapper">
                    {this.props.children}
                </div>
                {/*</div>*/}
                {this.state.haveToken && <Footer/>}


                <SidebarMobile show={this.state.sidebarMobile}
                               toggleSidebarMobile={this.toggleSidebarMobile}
                               onOpenModalLogin={this.onOpenModalLogin}
                               onOpenModalSignup={this.onOpenModalSignup}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // isAuthenticated: state.auth.isAuthenticated,
        isFetching: state.reducer.isFetching,
        // isCommonFetching: state.common.isFetching,
    };
}

export default connect(mapStateToProps)(Layout);
